import { type CouponSpecificProducts } from '@hooks-api/types/dataModel/coupon'
import { type ECommerceProduct } from '@hooks-api/types/dataModel/products'
import { type CouponSpecificProductsMap } from './PromotionCouponList'

export const parseCouponSpecificProductsMap = (
  couponSpecificProducts: CouponSpecificProducts[],
  productMap: Partial<Record<string, ECommerceProduct>>,
) => couponSpecificProducts.reduce<CouponSpecificProductsMap>((acc, specificProduct) => {
  acc.set(specificProduct.coupon_id, {
    coupon_id: specificProduct.coupon_id,
    product_groups: specificProduct.product_groups
      .map(productGroup => productGroup
        .map((product) => {
          const variation = productMap[product.product_id]
          if (!variation) return undefined
          return variation
        })
        .filter(product => product !== undefined)),
  })
  return acc
}, new Map())
